import { getPpccParamValueByNameAndPage } from '~globals/common';

import { CarrierPartnerContent } from '../child-layouts/CarrierPartner';

const DefaultContent = ({
    pageConfigs,
    template,
    partnerDisplayName,
}: {
    pageConfigs?: LandingPageConfig[];
    template?: string;
    partnerDisplayName?: string;
}) => {
    const headingH1 =
        getPpccParamValueByNameAndPage({
            pageCode: 'ehim_partner',
            pageConfigs: pageConfigs,
            paramName: 'headline',
        }) || "Compare the nation's top plans all in one place";

    const subheadingH2 =
        getPpccParamValueByNameAndPage({
            pageCode: 'ehim_partner',
            pageConfigs: pageConfigs,
            paramName: 'sub_header',
        }) || 'Find your Medicare match';

    const subheadingP =
        getPpccParamValueByNameAndPage({
            pageCode: 'ehim_partner',
            pageConfigs: pageConfigs,
            paramName: 'sub_header_2',
        }) ||
        'Your doctors, your prescriptions, your budget, and the additional benefits you want — compare plans, and enroll with no fee and no obligation.';

    return template === 'carrier-partner' ? (
        <CarrierPartnerContent partnerDisplayName={partnerDisplayName} />
    ) : (
        <>
            <h1 className="font-poppins font-bold">{headingH1}</h1>
            <h2 className="font-poppins font-bold">{subheadingH2}</h2>
            <p className="text-18 leading-28">{subheadingP}</p>
        </>
    );
};

export default DefaultContent;
